import { Zap } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import LoginStateManager from '../core/LoginStateManager';
import { useEffect, useState } from 'react';
import { MakeAxiosRequest } from '../core/utils';
import APIUrls from '../core/ApiUrls';
import InfoTooltip from './InfoTooltip';

const Sidebar = () => {
    const [alerts, setAlerts] = useState<number>(0);
    useEffect(() => {
        const hasAlerts = async () => {
            try {
                const res = await MakeAxiosRequest('GET', APIUrls.getURL('ALERTS') + '?highAlerts=true');
                if (res?.status === 200) {
                    // setAlerts(res?.data?.data?.amount);
                }
            } catch (error) {}
        };
        hasAlerts();
    }, []);
    return (
        <div className="h-screen w-52 border-r-[1px] border-gray-200 bg-white z-10 p-3 flex flex-col gap-2 flex-shrink-0">
            {/* Header */}
            <div className="flex items-center gap-1.5 mt-2 mb-10">
                <div className="w-7 h-7 bg-gradient-purple rounded-lg flex items-center justify-center">
                    <Zap className="w-4 h-4 text-white" />
                </div>
                <span className="font-bold text-sm text-sidebar-foreground">Clento Reporter</span>
            </div>
            <SideBarButton name="Home" navigateTo="/dashboard" alerts={alerts} />
            <SideBarButton name="Leads" navigateTo="/dashboard/leads" />
            <SideBarButton name="Companies" navigateTo="/dashboard/companies" />
            <SideBarButton name="Settings" navigateTo="/dashboard/settings" />
            <button onClick={() => LoginStateManager.logout()} className="bg-white hover:bg-red-600 hover:text-white border-[1px] transition text-black px-2 py-2 rounded-xl font-semibold shadow-sm whitespace-nowrap text-sm mt-auto">
                Log Out
            </button>
            {/* <SideBarButton name="Accounts" navigateTo="accounts" />  */} {/* move to the /dashboard*/}
        </div>
    );
};
export default Sidebar;

const SideBarButton = ({ name, navigateTo, icon, alerts }: { name: string; navigateTo: string; icon?: string; alerts?: number }) => {
    const navigate = useNavigate();
    const currentPath = useLocation().pathname;

    const selected = navigateTo === currentPath;
    return (
        // eslint-disable-next-line
        <button
            aria-selected={selected}
            onClick={() => navigate(navigateTo)}
            className={`
                w-full flex items-center gap-3 px-4 py-2
                rounded-xl border transition-all duration-200
                text-left font-medium text-sm

                border-transparent text-gray-700
                hover:hover-gradient-purple hover:text-white
                hover:border-purple-400

                aria-selected:bg-gradient-purple aria-selected:text-white
                aria-selected:border-purple-600 aria-selected:shadow-md`}>
            {icon && <span className="text-xl">{icon}</span>}
            {name}
            {!!alerts && alerts > 0 && alerts !== 0 && (
                <InfoTooltip className="ml-auto" info="High Priority alerts in the last 2 days">
                    <span
                        className="
                            inline-flex items-center justify-center
                            text-xs font-semibold bg-red-500 text-white
                            rounded-full min-w-[18px] h-[18px] px-1
                        ">
                        {alerts > 99 ? '99+' : alerts}
                    </span>
                </InfoTooltip>
            )}
        </button>
    );
};
